import {
  Component,
  Input,
  OnInit,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { bankList } from "../../../shared/payment/bank-list.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

export interface BankChangeEvent {
  originalEvent: MouseEvent;
  value: string;
}

@Component({
  selector: "app-bank-select",
  templateUrl: "./bank-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class BankSelectComponent implements OnInit {
  public readonly bankChange = output<string>();
  @Input() public bank;

  public subscription = new Subscription();
  public bankList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildBankList();
  }

  public onBankChange(event: BankChangeEvent) {
    this.bankChange.emit(event.value);
  }

  private buildBankList() {
    this.bankList.push({
      label: "None",
      value: null,
    });
    Object.keys(bankList).map((key) => {
      this.bankList.push({
        label: bankList[key],
        value: key,
      });
    });
  }
}
